module.exports = __webpack_public_path__ + "au.svg?497744bf6365f271fed917243815ec80";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/au.svg
// module id = 1188
// module chunks = 27